import { LoaderCircle } from 'lucide-react';
import { useSiteAccess } from '@/features/auth/use-auth';
import { useBrand } from '@/features/branding/brand-provider';
import { DemoCard } from '@/features/demo/demo-card';
import { BrandSettings } from '@/features/settings/brand-settings';
import { NotFound } from '@/routes/not-found';

// Ports app/[brand]/admin/settings/page.tsx. The Next page was a super-admin
// server component that awaited the current brand and rendered the Settings
// form plus the (super-admin-only) DemoCard. Here the brand comes from the
// BrandProvider, the super-admin gate comes from `useSiteAccess` (as the demo
// route does), and this renders content only — the admin <Shell> is provided
// by the route tree.
export function Settings() {
  const { brand, slug } = useBrand();
  const { access, loading: roleLoading } = useSiteAccess(slug);
  const isSuperAdmin = access?.superAdmin ?? false;

  if (roleLoading) {
    return (
      <div className="flex h-full items-center justify-center py-16">
        <LoaderCircle className="text-primary size-12 animate-spin" />
      </div>
    );
  }

  if (!isSuperAdmin) {
    return <NotFound />;
  }

  return (
    <>
      <BrandSettings site={brand} />
      {/* Super-admin-only demo controls; renders nothing otherwise. */}
      <DemoCard site={brand} />
    </>
  );
}
